import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './estilo.css'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('elemento #raiz não encontrado em index.html')

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// pede ao navegador para não apagar os dados quando faltar espaço
navigator.storage?.persist?.().catch(() => {})

// O service worker faz o app abrir sem sinal. Falha aqui não pode derrubar o app.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((erro) => console.warn('service worker não registrado:', erro))
  })
}
